import type { ReactElement } from 'react';
import type { CustomIconProps } from '../types';

export const ExternalLink = ({ width, height, dataTestId }: CustomIconProps): ReactElement => (
    <svg
        data-testid={`icon-${dataTestId}`}
        width={width ?? '40'}
        height={height ?? '40'}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1538 10H29.2308C29.6556 10 30 10.3444 30 10.7692V23.8462C30 24.271 29.6556 24.6154 29.2308 24.6154C28.8059 24.6154 28.4615 24.271 28.4615 23.8462V12.6263L11.3132 29.7747C11.0128 30.0751 10.5257 30.0751 10.2253 29.7747C9.9249 29.4743 9.9249 28.9872 10.2253 28.6868L27.3737 11.5385H16.1538C15.729 11.5385 15.3846 11.1941 15.3846 10.7692C15.3846 10.3444 15.729 10 16.1538 10Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
            fill="white"
        />
    </svg>
);
